module.exports = __webpack_public_path__ + "img/email.40865e25.png";